<script lang="ts">
/**
  * `<WaitButton>` component which you use exactly like regular `<button>` except that it also
  * takes an optional `wait` prop which, if set truthy, disables the button and puts it in an
  * animated wait state. If there's an `onclick` event handler and it happens to return a
  * `Promise`, the button will automatically set and remove its own `wait` state.
  * 
  * It's similar to Rails' `data-disable-with`, but it shows an animation instead of a different
  * label, and it works with `onclick` instead of a form submission.
  */

  import ThreeDotsScale from "../icons/ThreeDotsScale.svelte";

  let {
    onclick : outsideOnclick = undefined,
    wait : outsideWait = undefined,
    disabled = undefined,
    button = $bindable(),
    children,
    ...props
  } = $props()

  let promiseWait = $state()
  let wait = $derived(outsideWait || promiseWait)
  let onclick = $derived(outsideOnclick && function(...args){
    const result = outsideOnclick.apply(this, args);
    if(typeof result?.finally === "function") {
      promiseWait = true
      result.finally(()=>promiseWait = false)
    }
    return result
  })
</script>
<button bind:this={button} {onclick} disabled={disabled || wait} class:relative={true} {...props}>
  <span class:invisible={wait}>{@render children()}</span>
  {#if wait}<ThreeDotsScale class="w-8 h-8 -mt-4 -ml-4 absolute left-[50%] top-[50%]" speed={0.7} />{/if}
</button>